export enum PartnerVisaStatus {
  APPLYING_DEPENDANT = 'APPLYING_DEPENDANT',
  APPLYING_DIFFERENT = 'APPLYING_DIFFERENT',
  READY_TO_TRAVEL_VALID = 'READY_TO_TRAVEL_VALID',
  ALREADY_IN_UK_VALID = 'ALREADY_IN_UK_VALID',
  NONE = 'NONE'
}

export enum OrgType {
  UK_GOV = 'UK Government',
  BRITISH_GOV = 'British Council',
  YOUR_GOV = 'Your Government',
  INT_ORG = 'International Organisation',
  INT_COMP = 'International Company'
}

export enum FamilySponsorType {
  STANDARD = 'STANDARD',
  TERM_DEPOSIT = 'TERM_DEPOSIT',
  SAVINGS = 'SAVINGS',
  INVESTMENT = 'INVESTMENT',
  PENSION = 'PENSION'
}

export enum LoanType {
  NATIONAL_GOV = 'NATIONAL_GOV',
  STATE_GOV = 'STATE_GOV',
  LOAN_COMP = 'LOAN_COMP',
  LOAN_SCHEME = 'LOAN_SCHEME',
  UNKNOWN = 'UNKNOWN',
  OTHER = 'OTHER'
}
